import { usePostUserRequestsUploadDocument } from '@/shared/api'

export const useRequestUploadDocument = () => {
    const { mutateAsync: uploadDocument, isPending } = usePostUserRequestsUploadDocument()

    return {
        uploadDocument,
        isPending,
    }
}
